// web-v2/src/lib/openDocument.js
// The surfaces' handle on services/docs-open.service.js: the same open, with its notices on a toast
// (a warning routed to the console is a warning that was not issued).
import { toast } from '@/components/ui/toaster.jsx';
import { openDocument as openThroughDoor, openStoredDocument as openStoredThroughDoor } from '@/services/docs-open.service.js';

export function openDocument(permalink) {
  return openThroughDoor(permalink, { notify: (m) => toast.info(m) });
}

// A stored (Supabase) copy, deals-door-1 answers round 3 R2d-Q1.
export function openStoredDocument(documentId) {
  return openStoredThroughDoor(documentId, { notify: (m) => toast.info(m) });
}
